import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  Card,
  Typography,
  Button,
  MenuItem,
  Grid,
  TextField
} from '@material-ui/core';
import * as yup from 'yup';
import {Formik} from 'formik';
import {addHelpSubCategoryApi, editHelpSubCategoryApi} from 'api/help';
import { BackdropCircular } from 'components';


const SubTabsForm = ({subCategory, setSubCategory}) => {
  const dispatch = useDispatch();
  const {helpCategories, isLoadingHelpSubCategories } = useSelector((state) => state.help);

  return (
    <>
      <Card
        className="p-4 m-4"
        elevation={25}
      >
        <Formik
          initialValues={{
            _id: subCategory._id || '',
            title: subCategory.title || '',
            path: subCategory.path || '',
            icon: subCategory.icon || '',
            category: subCategory?.category?._id || ''
          }}
          onSubmit={async (values) => {
            const {title, path, icon, category} = values;

            if (subCategory._id) {
              editHelpSubCategoryApi({dispatch, subCategory: values });
            } else {
              addHelpSubCategoryApi({dispatch, subCategory: {title, path, icon, category}});
            }

            setSubCategory(null);
          }}
          validationSchema={
            yup.object({
              title: yup
                .string()
                .required('Field is required'),
              path: yup
                .string()
                .required('Field is required'),
              icon: yup
                .string()
                .required('Field is required')
            })
          }
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit
          }) => (
            <form autoComplete="off" className="p-8" onSubmit={handleSubmit}>
              <Grid container spacing={3} className="p-4">
                <Grid item xs={12} sm={12} md={12}>
                  <Typography variant="h5" className="text-brand my-5">Add Sub-Category</Typography>
                  <TextField
                    className="w-full"
                    name="category"
                    value={values.category}
                    label="Category"
                    select
                    variant="outlined"
                    onChange={handleChange}
                  >
                    {helpCategories.map((category) => (
                      <MenuItem key={category._id} value={category._id}>{category.title}</MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    required
                    className="w-full mt-10"
                    label="Sub categories title"
                    name="title"
                    variant="outlined"
                    value={values.title}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.title && Boolean(errors.title)}
                    helperText={touched.title && errors.title}
                  />
                  <TextField
                    required
                    className="w-full mt-10"
                    label="Path"
                    name="path"
                    variant="outlined"
                    value={values.path}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.path && Boolean(errors.path)}
                    helperText={touched.path && errors.path}
                  />
                  <TextField
                    required
                    className="w-full mt-10"
                    label="Icon"
                    name="icon"
                    variant="outlined"
                    value={values.icon}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.icon && Boolean(errors.icon)}
                    helperText={touched.icon && errors.icon}
                  />
                  <div className="flex items-center justify-end mt-8">
                    <Button
                      variant="contained"
                      onClick={() => setSubCategory(null)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      className="mx-10"
                      type="submit"
                    >
                      {values._id ? 'Edit Sub-Category' : 'Save Sub-Category'}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Card>
      <BackdropCircular loading={isLoadingHelpSubCategories} />
    </>
  );
};

export default SubTabsForm;
